import pkg from '../../package.json'

const getVersion = () => pkg.version

export const getWintlVersion = () => pkg.dependencies['@weenat/wintl']
export const getClientVersion = () => pkg.dependencies['@weenat/client']

export default getVersion
